import EfImg from '@elem/ui/ef-img';
import { useProductStore } from '../../ProductProvider';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    const { pageType } = useProductStore();
    const BG_MAP: any = {
        [PAGE_TYPE.BASE]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726040621050/pc_ksp_06_base.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1726040621050/pc_ksp_06_base.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726040614909/m_ksp_06_base.jpg',
        },
        [PAGE_TYPE.MOTOR]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726121328886/pc_ksp_06.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1726121328886/pc_ksp_06.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726639174782/m_ksp_06_tm.jpg',
        },
    };
    const bg = BG_MAP[pageType];

    return (
        <div className={styles.itemSelling}>
            <EfImg pc={bg.pc} pad={bg.pad} h5={bg.h5} />
            <div className="item-desc-f">
                <div className="item-line-1">{t('f_ms1')}</div>
                <div className="item-line-2">{t('f_ms2')}</div>
                <div className="item-line-3">{t('f_ms3')}</div>
                <div className="item-line-4">{t('f_ms4')}</div>
            </div>
        </div>
    );
}
